'use es6';

import EmailAssetDialogContainer from './EmailAssetDialogContainer';
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import { useUserRoleForReport } from '../../../utils/trackingUtils';
import { getId, getName } from '../../../data/schemas/reportSchema';
import { REPORT_OBJECT_TYPE } from 'dashboard-lib/public/emails/emails';
import { getDefaultSavedReportActionEventProperties } from '../../report-action-wrapper';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
const REPORTS_LIST_BASE_URL = '/reports-list';
const scheduledSharedAssetPropDefault = {};
const EmailReportDialogContainer = ({
  appUsageTracker,
  onEditSuccess = noop,
  report,
  scheduledSharedAsset = scheduledSharedAssetPropDefault
}) => {
  const reportId = getId(report);
  const previewUrl = `${REPORTS_LIST_BASE_URL}/${PortalIdParser.get()}/export/${reportId}`;
  const userRole = useUserRoleForReport(report);
  return /*#__PURE__*/_jsx(EmailAssetDialogContainer, {
    appUsageTracker: appUsageTracker,
    report: report,
    onEditSuccess: onEditSuccess,
    scheduledSharedAsset: scheduledSharedAsset,
    objectId: reportId,
    objectType: REPORT_OBJECT_TYPE,
    assetName: getName(report),
    previewUrl: previewUrl,
    assetSpecificTrackingProps: Object.assign({}, getDefaultSavedReportActionEventProperties(report), {
      role: userRole
    })
  });
};
EmailReportDialogContainer.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  onEditSuccess: PropTypes.func,
  report: PropTypes.object.isRequired,
  scheduledSharedAsset: PropTypes.object
};
export default EmailReportDialogContainer;